var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"iconTable_content",staticClass:"iconTable_content",staticStyle:{"font-size":"16px","width":"100%","background":"#eff1f5"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }